export const faqData = [
  {
    question: "Apakah ada akses trial?",
    answer:
      "Ya, kamu mendapatkan akses trial gratis selama 3 hari untuk mencoba seluruh fitur undangan. Setelah masa trial berakhir, kamu perlu memilih salah satu paket agar undangan tetap aktif. Jika belum memilih paket, undangan akan otomatis terkunci (lock) dan tidak dapat diakses sampai kamu melakukan aktivasi.",
  },
  {
    question: "Apakah undangan memiliki batas masa aktif?",
    answer:
      "Tidak ada batas masa aktif, jadi undangan kamu tetap bisa diakses selama yang kamu butuhkan. Namun perlu dicatat bahwa satu undangan hanya berlaku untuk satu kali acara, sehingga tidak bisa dipakai ulang atau diganti-ganti untuk acara yang berbeda.",
  },
  {
    question: "Apakah bisa upgrade paket kapan saja?",
    answer:
      "Bisa, kamu dapat melakukan upgrade paket kapan saja sesuai kebutuhan acaramu, misalnya dari Basic ke Pro atau Premium. Perlu diingat bahwa proses hanya berlaku satu arah, sehingga paket tidak dapat di-downgrade kembali ke tingkat yang lebih rendah setelah di-upgrade.",
  },
  {
    question: "Apakah bisa custom tema sesuai desain dari saya?",
    answer:
      "Bisa. Untuk kebutuhan desain khusus sesuai keinginanmu, kamu bisa memilih paket Premium yang menyediakan layanan custom design. Tim kami akan membantu mewujudkan tema undangan sesuai konsep dan referensi yang kamu berikan.",
  },
  {
    question: "Apakah undangan digital ini hanya khusus pernikahan?",
    answer:
      "Tidak. Undangan digital Elynk.co dapat digunakan untuk berbagai jenis acara, seperti ulang tahun, khitanan, aqiqah, wisuda, acara korporasi, hingga gathering keluarga. Kamu bebas menyesuaikan tema dan isi undangan dengan jenis acaramu.",
  },
  {
    question: "Bisakah membuat undangan dengan bahasa selain bahasa Indonesia?",
    answer:
      "Bisa. Melalui fitur custom localization, kamu dapat membuat undangan dalam bahasa apa pun sesuai kebutuhan, termasuk bahasa asing. Fitur ini bahkan mendukung penggunaan bahasa daerah, sehingga undangan terasa lebih personal dan sesuai dengan latar acaramu.",
  },
  {
    question: "Apakah bisa refund pembayaran?",
    answer:
      "Bisa. Kamu berhak mendapatkan refund 100% selama undangan belum pernah digunakan atau disebarkan kepada tamu. Apabila undangan sudah aktif dan dibagikan, maka pembayaran tidak dapat dikembalikan.",
  },
]